import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer id="footer" className="relative border-t border-white/[0.05] overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 pt-16 pb-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-10 py-10">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-5 text-sm text-[#8a8a8a] max-w-xs">{t.footer.tagline}</p>
          </div>
          {[["col1", "c1"], ["col2", "c2"], ["col3", "c3"]].map(([title, list], i) => (
            <div key={title} className={`lg:col-span-2 ${i === 0 ? "lg:col-start-7" : ""}`}>
              <h4 className="font-mono text-[0.65rem] tracking-[0.25em] uppercase text-[#00f2fe] mb-5">{t.footer[title]}</h4>
              <ul className="space-y-3">
                {t.footer[list].map((l) => (
                  <li key={l}>
                    <a href="#top" className="nav-link text-sm" data-testid={`footer-link-${list}-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-4 pt-8 border-t border-white/[0.06] text-xs text-[#555] font-mono tracking-wider">
          <span data-testid="footer-copyright">© 2023 rojdijital. {t.footer.rights}</span>
          <span>Kazakhstan</span>
        </div>
      </div>

      <div className="pointer-events-none select-none font-display font-extrabold text-[13vw] leading-[0.75] tracking-[-0.04em] text-center text-[#00f2fe]/[0.05] translate-y-[22%]" aria-hidden>
        rojdijital
      </div>
    </footer>
  );
};
